import { COLLECTIONS } from "constants/action-types";
import { SchemaKeyMap } from "helpers/product-collection";
import { List } from "immutable";

export type ActionOverrideItemDisplayNamePayload = {
    fieldName: string;
    newDisplayName: string;
};

export const overrideItemDisplayName = ({ fieldName, newDisplayName }: ActionOverrideItemDisplayNamePayload) => ({
    payload: { fieldName, newDisplayName },
    type: COLLECTIONS.COLLECTION.ITEM_DISPLAY_PROPERTY.OVERRIDE_DISPLAY_NAME.MUTATE,
});

export const initDependentsFieldsLookupMap = (payload: { schemaList: List<SchemaKeyMap> }) => ({
    payload,
    type: COLLECTIONS.COLLECTION.ITEM_DISPLAY_PROPERTY.INIT_DEPENDENTS_FIELDS_LOOKUP_MAP,
});
